import './options-toolbar.scss'

import { Component, Watch } from 'vue-property-decorator'
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons'

import { SearchParams } from '@skinsoft/types'
import { EntityFieldDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    props: ['sortingEntityFields'],
    template: require('./options-toolbar.html'),
})
export class OptionsToolbar extends ReactiveVue {

    public sortingEntityFields: any[];

    private sortOptions: any[] = [];
    private $entityFieldDataStore: EntityFieldDataStore;

    // Icons
    private sortAscIcon = faSortAmountUp;
    private sortDescIcon = faSortAmountDown;

    private options: Partial<SearchParams> = {
        sortAsc: false,
        sortType: '',
    };

    public async populateSelectOptions() {
        let index = 0;
        // Setting options from config file
        for (const entityField of this.sortingEntityFields) {
            const entityFieldId = await this.$entityFieldDataStore.getEntityFieldId(
                entityField.entityFieldName,
                entityField.entityName,
                entityField.schemaName)

            this.sortOptions.push({
                label: entityField.i18nKey,
                value: entityFieldId
            })

            // Setting default sort option (first in config file)
            if (index === 0) {
                this.options.sortType = entityFieldId;
            }
            index++;
        }
    }
    private toggleSortAsc() {
        this.options.sortAsc = !this.options.sortAsc;
    }

    @Watch('options', { immediate: true, deep: true })
    private onValueChange() {
        this.$emit('change', this.options);
    }

    @Watch('sortingEntityFields')
    private onSortingEntityFieldsChange() {
        this.populateSelectOptions()
    }
}
